module.exports = __webpack_public_path__ + "static/media/microgaming.07830e60.png";